import React from "react";
import FJButton from 'fj-components/FJButton'
import styles from './FJMediaStatusToolbarView.module.less';


function FJMediaStatusToolbarView(props) {
	return (
		<>
			<FJButton style={{float: 'left'}}
								text={props.text}
								className={styles.button_container}
								textClass={styles.text_box}
								icon={props.icon}
								iconClass={styles.icon_box}
								onClick={props.onClick}
			/>
			<div className={styles.info}>
				{props.info}
			</div>
		</>
	)
}

export default FJMediaStatusToolbarView;